import Vue from 'vue';
import Components from '@we-are-ocus/ocus-components';
import '@we-are-ocus/ocus-components/dist/ocus-components.css';

Vue.component('Search', Components.Search);
Vue.component('SearchAutocomplete', Components.SearchAutocomplete);
Vue.component('Combobox', Components.Combobox);
Vue.component('Tabs', Components.Tabs);
Vue.component('TextInput', Components.TextInput);
Vue.component('Tooltip', Components.Tooltip);
Vue.component('Tag', Components.Tag);
Vue.component('Blocker', Components.Blocker);
Vue.component('Dateshower', Components.Dateshower);
Vue.component('Btn', Components.Btn);
Vue.component('MenuSelect', Components.MenuSelect);
Vue.component('DenseDatePicker', Components.DenseDatePicker);
Vue.component('SimpleSelect', Components.SimpleSelect);
Vue.component('MultipleSelect', Components.MultipleSelect);
Vue.component('Autocomplete', Components.Autocomplete);
Vue.component('HistoryLog', Components.HistoryLog);
Vue.component('TimeSelect', Components.TimeSelect);
Vue.component('Pagination', Components.Pagination);
Vue.component('User', Components.User);
Vue.component('NotifierDisplay', Components.NotifierDisplay);
Vue.component('SkillCheckbox', Components.SkillCheckbox);
